const imageStyles = { width: '30%' }

export default imageStyles
